import LoginError from './LoginError';
class InvalidUnlockLink extends LoginError {
    constructor(email, options) {
        super(`The unlock link for '${email}' is invalid or has been tampered with`, options);
    }
}
export default InvalidUnlockLink;
